 if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartPopup = document.querySelector('cart-popup');
      this.enabled = true;
    }
    
    enableButton(preorder) {
      if ( preorder ) {
        this.querySelector('[type="submit"]').innerHTML = "Preorder Now"
      } else {
        this.querySelector('[type="submit"]').innerHTML = "Buy Now"
      }
      this.enabled = true;
    }

    disableButton() {
      this.enabled = false;
      this.querySelector('[type="submit"]').innerHTML = "Select Your Options"
    }
    
     onSubmitHandler(evt) {
      evt.preventDefault();
      if ( !this.enabled ) {
        return;
      }
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartPopup.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.cartPopup.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.full-cart'
        }
      ];
    }

  });
}